import Vue from 'vue';
import OfsMenu, { OfsForm, OfsFeatureToggle } from '@oneflow/ofs-vue-layout';
import BootstrapVue from 'bootstrap-vue';
import VueCarousel from 'vue-carousel';
import ClickOutside from 'vue-click-outside';
import './style/index.scss';
import store, { i18n } from './vuex';
import router, { menuStructure } from './router';
import App from './App';
import './registerServiceWorker';
import packageJson from '../package.json';
import config from './config';

window.$config = Object.assign({}, window.$config, config);

const sentryKey = window.$config.sentryKey;
if (sentryKey && window.location.hostname !== 'localhost') {
	Sentry.init({
		dsn: sentryKey,
		release: packageJson.version,
		environment: window.$config.environment,
		integrations: [new Integrations.Vue({ Vue })]
	});
}

Vue.config.productionTip = false;
Vue.use(OfsMenu, { router, store, menu: menuStructure });
Vue.use(BootstrapVue);
Vue.use(OfsForm, { store });
Vue.use(OfsFeatureToggle, { store });
Vue.use(VueCarousel);

Vue.directive('click-outside', ClickOutside);

/* eslint-disable no-new */
new Vue({
	i18n,
	router,
	el: '#app',
	store,
	components: { App },
	template: '<App/>'
});
